import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../../constants/urlConstants/configuration";

const { inmobiusJobBaseUrl, inmobiusJobApiVersion } = CONFIG_VARS;

export const schoolAuthApi = createApi({
  reducerPath: "schoolAuthApi",
  baseQuery: fetchBaseQuery({
    baseUrl: inmobiusJobBaseUrl["1"],
    prepareHeaders: (headers) => {
      headers.set("tenant-id", "99999");
      headers.set("product-id", "100");
      headers.set("platform", "web");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    schoolAdminLogin: builder.mutation({
      query: (data) => ({
        url: `${inmobiusJobApiVersion}/onboarding/school-login`,
        method: "POST",
        body: data.body,
      }),
    }),
  }),
});

export const { useSchoolAdminLoginMutation } = schoolAuthApi;
